export default "__VITE_ASSET__BpVoqdG9__"